import {Component, signal, inject, ChangeDetectionStrategy} from "@angular/core"
import {FormsModule} from "@angular/forms"
import {MatButtonModule} from "@angular/material/button"
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle} from "@angular/material/dialog"
import {MatInputModule} from "@angular/material/input"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-rename-dialog",
    templateUrl: "./rename-dialog.component.html",
    styleUrls: ["./rename-dialog.component.scss"],
    imports: [MatInputModule, MatDialogContent, MatDialogTitle, MatDialogActions, MatButtonModule, FormsModule],
})
export class RenameDialogComponent {
    readonly $name = signal<string | undefined>(undefined)
    readonly $caption = signal<string | undefined>(undefined)
    readonly $confirmLabel = signal("Rename")
    readonly $allowUndefined = signal<boolean | undefined>(undefined)
    readonly dialogRef = inject(MatDialogRef<RenameDialogComponent>)
    readonly data = inject<{currentName: string; caption: string; confirmLabel?: string; allowUndefined?: boolean}>(MAT_DIALOG_DATA)

    constructor() {
        this.$name.set(this.data.currentName)
        this.$caption.set(this.data.caption ?? "Rename")
        this.$confirmLabel.set(this.data.confirmLabel ?? "Rename")
        this.$allowUndefined.set(this.data.allowUndefined ?? false)
    }

    selectNameWithoutExtension(input: HTMLInputElement): void {
        const lastDotIndex: number = input.value.lastIndexOf(".")
        if (lastDotIndex > 0) {
            input.setSelectionRange(0, lastDotIndex)
        } else {
            input.setSelectionRange(0, input.value.length)
        }
    }

    cancelAction(): void {
        this.dialogRef.close(false)
    }

    confirmAction(): void {
        this.dialogRef.close(this.$name())
    }
}
